import request from './core/request'

// 商品相关API
export default {
	//获取商品分类
	getGoodsCategoryList: (expertId) => request.get(`/mobile/getGoodsCategoryList/${expertId}`),
	//获取商品品牌
	getGoodsBrandList: (data) => request.post(`/mobile/getGoodsBrandList`, data),
	//获取商品列表
	getGoodsList: (params) => request.get(`/mobile/getGoodsList`, params),
	//获取商品品质列表
	getGoodsTagList: (params) => request.post(`/mobile/getGoodsTagList`, params),
    // 获取首页菜单配置信息
    getHomeConfig: () => request.get(`/mobile/getHomeConfig`),
	// menuList` | Array | 菜单配置列表（JSON数组） |
}